import React, { useState } from 'react';
import { OverlayTrigger, Tooltip, InputGroup, FormControl, Button, Container, Row, Col } from 'react-bootstrap';
import copy from 'copy-to-clipboard';
import BookmarkSVG from './svgs/bookmark';
var Article = function Article(_ref) {
    var children = _ref.children, title = _ref.title, pageUrl = _ref.pageUrl;
    var slugify = function slugify(text) {
        return text.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-');
    };
    var sluggedTitle = slugify(title);
    var anchorLink = pageUrl + "#" + sluggedTitle;
    var _useState = useState(false), show = _useState[0], setShow = _useState[1];
    var handleClick = function handleClick(event) {
        setShow(true);
        setTimeout(function () {
            return setShow(false);
        }, 1000);
        copy(anchorLink);
        event.preventDefault();
    };
    return /*#__PURE__*/ React.createElement("article", {
        className: "border-bottom pt-5 pb-7 pt-lg-6 pb-lg-8",
        id: sluggedTitle
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Row, {
        className: "mb-7 mb-lg-8"
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: 6,
        sm: 7,
        md: 8,
        lg: 9
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "h4 font-weight-bolder mb-0 text-capitalize"
    }, title)), /*#__PURE__*/ React.createElement(Col, {
        xs: 6,
        sm: 5,
        md: 4,
        lg: 3,
        className: "text-right text-lg-left"
    }, /*#__PURE__*/ React.createElement(InputGroup, {
        size: "sm"
    }, /*#__PURE__*/ React.createElement(FormControl, {
        readOnly: true,
        "aria-describedby": "basic-addon2",
        defaultValue: anchorLink
    }), /*#__PURE__*/ React.createElement(OverlayTrigger, {
        trigger: ['hover', 'click'],
        placement: "bottom-end",
        delay: {
            show: 0,
            hide: 0
        },
        overlay: /*#__PURE__*/ React.createElement(Tooltip, {
            id: sluggedTitle + "-tooltip-onboard"
        }, "Copy Bookmark")
    }, /*#__PURE__*/ React.createElement(InputGroup.Append, null, /*#__PURE__*/ React.createElement(OverlayTrigger, {
        trigger: ['hover', 'focus'],
        placement: "bottom-end",
        delay: {
            show: 0,
            hide: 450
        },
        show: show,
        overlay: /*#__PURE__*/ React.createElement(Tooltip, {
            id: sluggedTitle + "-tooltip-onboard"
        }, "Copied!")
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "dark",
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(BookmarkSVG, {
        height: "14",
        className: "svg-fill-light"
    })))))))), /*#__PURE__*/ React.createElement(Row, {
        className: "justify-content-center"
    }, /*#__PURE__*/ React.createElement(Col, {
        lg: 10,
        xl: 8
    }, children))));
};
export default Article;
